module.exports = __webpack_public_path__ + "static/img/1000000438_blue.28dfc903.jpg";